var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row bg-dark mb-3"},[_c('div',{staticClass:"col"},[_c('h4',{staticClass:"mt-3 mb-3"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }